var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
export var initialState = {
    view: null,
    viewLoaded: false,
    filter: {
        page: 1,
        sort: 'marks',
        marksCheck: [],
        blockPage: 10,
        pageSize: 10,
        marks: 0
    },
    topFilterNum: 'marks',
    setReviewLoadingState: false,
    reviewInfo: null,
    comment: {
        writer: {},
    },
    galleryData: {},
    galleryItem: 0 //갤러리 파일 순서 번호(상품평의 첨부파일 중 몇번째의 첨부파일인지)
};
export var S_REVIEW_LIST_REQUEST = 'S_REVIEW_LIST_REQUEST';
export var S_REVIEW_LIST_SUCCESS = 'S_REVIEW_LIST_SUCCESS';
export var S_REVIEW_LIST_FAILURE = 'S_REVIEW_LIST_FAILURE';
export var SET_FILTER_S_REVIEW = 'SET_FILTER_S_REVIEW';
export var SET_FILTER_TOP_STATE = 'SET_FILTER_TOP_STATE';
export var SET_S_REVIEW_LOADING_STATE = 'SET_S_REVIEW_LOADING_STATE';
export var GET_S_REVIEW_INFO = "GET_S_REVIEW_INFO";
export var GET_S_REVIEW_INFO_SUCCESS = "GET_S_REVIEW_INFO_SUCCESS";
export var GET_S_REVIEW_INFO_FAILURE = "GET_S_REVIEW_INFO_FAILURE";
export var SET_S_REVIEW_COMMENT_CREATE = "SET_S_REVIEW_COMMENT_CREATE";
export var SET_S_REVIEW_COMMENT_UPDATE = "SET_S_REVIEW_COMMENT_UPDATE";
export var SET_S_REVIEW_COMMENT_DELETE = "SET_S_REVIEW_COMMENT_DELETE";
export var SET_S_REVIEW_GALLERY_ITEM = "SET_S_REVIEW_GALLERY_ITEM";
export var SET_FILTER_S_REVIEW_RESET = "SET_FILTER_S_REVIEW_RESET";
var Reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    return produce(state, function (draft) {
        var _a, _b, _c, _d;
        switch (action.type) {
            //
            case S_REVIEW_LIST_REQUEST: {
                break;
            }
            case S_REVIEW_LIST_SUCCESS: {
                draft.viewLoaded = true;
                draft.view = action.data;
                break;
            }
            case S_REVIEW_LIST_FAILURE: {
                draft.viewLoaded = true;
                break;
            }
            //
            case SET_FILTER_S_REVIEW: {
                draft.filter = __assign(__assign({}, state.filter), action.payload);
                break;
            }
            case SET_FILTER_TOP_STATE: {
                draft.topFilterNum = action.payload;
                break;
            }
            case SET_S_REVIEW_LOADING_STATE: {
                draft.setReviewLoadingState = action.payload;
                break;
            }
            case GET_S_REVIEW_INFO: {
                break;
            }
            case GET_S_REVIEW_INFO_SUCCESS: {
                draft.viewLoaded = true;
                draft.reviewInfo = action.data;
                // if(action?.data?.auth?.length>0){
                //     draft.comment = {
                //         writer: { ...action?.data?.auth[0] },
                //     }
                // }
                //
                if (((_b = (_a = action === null || action === void 0 ? void 0 : action.data) === null || _a === void 0 ? void 0 : _a.reviewImages) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    var galleryImages = (_c = action === null || action === void 0 ? void 0 : action.data) === null || _c === void 0 ? void 0 : _c.reviewImages;
                    var galleryCount = (_d = action === null || action === void 0 ? void 0 : action.data) === null || _d === void 0 ? void 0 : _d.reviewImagesCount;
                    var images = [];
                    var imageCount = 0;
                    for (var i = 0; i < galleryImages.length; i++) {
                        var id = galleryImages[i].id;
                        var files = galleryImages[i].marketMedia;
                        for (var j = 0; j < files.length; j++) {
                            var index = files[j].index;
                            var type = files[j].type;
                            var url = files[j].url;
                            images.push({ reviewId: id, type: type, url: url });
                            imageCount++;
                            if (imageCount === 8)
                                break;
                        }
                        if (imageCount === 8)
                            break;
                    }
                    draft.galleryData = { images: images, count: galleryCount };
                }
                break;
            }
            case GET_S_REVIEW_INFO_FAILURE: {
                draft.viewLoaded = true;
                break;
            }
            case SET_S_REVIEW_COMMENT_CREATE: {
                var lists = state.view.threads;
                var reviewIndex_1 = lists.findIndex(function (v) { return v.id === action.payload.review_id; });
                if (reviewIndex_1 !== -1) {
                    // 기존 comments에 등록한 comment추가
                    var updateComments_1 = __spreadArray(__spreadArray([], lists[reviewIndex_1].comments, true), [action.payload.review_data], false);
                    // draft.view 업데이트
                    draft.view = __assign(__assign({}, draft.view), { threads: lists.map(function (thread, i) {
                            return i === reviewIndex_1
                                ? __assign(__assign({}, thread), { comments: updateComments_1 }) : thread;
                        }) });
                }
                break;
            }
            case SET_S_REVIEW_COMMENT_UPDATE: {
                var lists = state.view.threads;
                var reviewIndex_2 = lists.findIndex(function (v) { return v.id === action.payload.review_id; });
                if (reviewIndex_2 !== -1) {
                    var comments = lists[reviewIndex_2].comments;
                    var commentIndex = comments.findIndex(function (v) { var _a; return (v === null || v === void 0 ? void 0 : v.id) === ((_a = action.payload.comment_data) === null || _a === void 0 ? void 0 : _a.id); });
                    if (commentIndex !== -1) {
                        var updatedComments_1 = __spreadArray(__spreadArray(__spreadArray([], comments.slice(0, commentIndex), true), [
                            action.payload.comment_data
                        ], false), comments.slice(commentIndex + 1), true);
                        draft.view = __assign(__assign({}, draft.view), { threads: lists.map(function (thread, i) {
                                return i === reviewIndex_2
                                    ? __assign(__assign({}, thread), { comments: updatedComments_1 }) : thread;
                            }) });
                    }
                }
                break;
            }
            case SET_S_REVIEW_COMMENT_DELETE: {
                var lists = state.view.threads;
                var review_id = action.payload.review_id;
                var comment_id_1 = action.payload.comment_id;
                var reviewIndex_3 = lists.findIndex(function (v) { return v.id === action.payload.review_id; });
                if (reviewIndex_3 !== -1) {
                    var existingThread = lists[reviewIndex_3];
                    var updatedComments_2 = existingThread.comments.filter(function (comment) { return comment.id !== comment_id_1; });
                    draft.view = __assign(__assign({}, draft.view), { threads: lists.map(function (thread, i) {
                            return i === reviewIndex_3
                                ? __assign(__assign({}, thread), { comments: updatedComments_2 }) : thread;
                        }) });
                }
                break;
            }
            case SET_S_REVIEW_GALLERY_ITEM: {
                draft.galleryItem = action.payload.galleryItem;
                break;
            }
            case SET_FILTER_S_REVIEW_RESET: {
                draft.filter = {
                    page: 1,
                    sort: 'marks',
                    marksCheck: [],
                    blockPage: 10,
                    pageSize: 10,
                    marks: 0
                };
                break;
            }
            default: {
                break;
            }
        }
    });
};
export default Reducer;



//////////////////
// WEBPACK FOOTER
// ./src/detail/reducers/shoppingReview.ts
// module id = 22
// module chunks = 0